module.exports = __webpack_public_path__ + "static/media/eye-view.993648f8.svg";